import type { PricingVersionFormat, PricingVersionTuple } from '../../model/model.ts'

type NlRcphPricingVersionFormat = PricingVersionFormat<'nl-rcp-hiscox'>

export const nlRcphPricingVersions = [
  ['pricing-nl-rcp-hiscox-1.0.0-2026-05-21', { label: 'Version 1' }],
] as const satisfies PricingVersionTuple<NlRcphPricingVersionFormat>[]

export type NlRcphPricingVersion = (typeof nlRcphPricingVersions)[number][0]
